import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from 'components_v2/common/CardV2';
import Link from 'components/Link';
import ImageV2 from 'components_v2/common/ImageV2';
import makeRequest from 'utils/makeRequest';
import Lineshimmer from 'components_v2/common/LineShimmer/lineshimmer';
import RelatedStoriesCardBottom from 'components_v2/mobile/RelatedStoriesCardBottom/RelatedStoriesCardBottom';
import s from './LiveblogInsert.scss';
import { TOI_IMAGE_DOMAIN } from '../../../../../constants';
import CardBottom from '../../../../../components_v2/common/CardV2/CardBottom';

class LiveblogInsert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: !props.isLead && props.sectionData && props.sectionData.dataUrl,
    };
  }

  componentDidMount() {
    const { sectionData, isBudget } = this.props;
    // if (
    //   !isLead &&
    //   sectionData &&
    //   !Array.isArray(sectionData) &&
    //   sectionData.dataUrl
    // ) {
    //   // this.loadLBData(sectionData.dataUrl);
    // }
    if (
      sectionData &&
      isBudget &&
      !Array.isArray(sectionData) &&
      sectionData.dataUrl
    ) {
      this.loadLBData(sectionData.dataUrl);
    }
  }

  loadLBData(dataUrl) {
    if (!dataUrl) {
      return;
    }

    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (data && data.data) {
          //console.log('data : ', data.data);
          this.setState({ loading: false });
          this.setState({ data: data.data });
        }
      });
  }

  render() {
    const {
      sectionData,
      isLead,
      itemIndex,
      gaAction,
      datanewga,
      insertCaption,
      sectionId,
      ga4Type,
      enableRelatedStoriesSupport,
      isCtnCpd,
      isBudget,
    } = this.props;
    const { data } = this.state;
    if (!isBudget) {
      sectionData.dataUrl = null;
    }
    const imgWidth =
      this.props.imgWidth || (this.props.isMobile ? '160' : '300');
    if (isLead) {
      return (
        <Card
          data={sectionData}
          // showDescription={itemIndex <= leadImageUpperLimit}
          isLeadImageNews={isLead}
          isInlineSmallIconCard={!isLead}
          itemClass={`${itemIndex >= 0 && s.leadspacing}`}
          linkData={{
            gaAction: `${gaAction}-${itemIndex}`,
            gaLabel: `${sectionData.wu}`,
          }}
          insertCaptionPlatform={insertCaption ? 'mobile' : ''}
          shouldNotlazyloadImage={
            sectionId === 'topstories' && sectionData.type === 'featured'
          }
          ga4Type={sectionId === 'topstories' ? 'top_stories' : ''}
          enableRelatedStoriesSupport={enableRelatedStoriesSupport}
          isCtnCpd={isCtnCpd}
        />
      );
    } else if (sectionData && !sectionData.dataUrl) {
      const isRelatedStoriesPresent =
        enableRelatedStoriesSupport &&
        Array.isArray(sectionData.relatedStories) &&
        sectionData.relatedStories.length > 1;
      return (
        <>
          <div
            className={`${s.LB_wrapper} ${
              isRelatedStoriesPresent ? `${s.Lb_inline_related}` : ''
            }`}
          >
            <Link
              className={`${s.LB_timeline_wrapper} ${s.LB_heading}`}
              to={sectionData.wu}
              data={{
                gaAction: `${gaAction}-${itemIndex}`,
                gaLabel: `${sectionData.wu}`,
              }}
            >
              <div className={`${s.LB_timeline} ${s.LB_headingonly}`}>
                <div className={s.storyWrap}>
                  {/* {' '} */}
                  {/* <span className={s.liveBlinker}>
                    {isRelatedStoriesPresent ? ' LIVE ' : ''}
                  </span> */}
                  <figcaption>
                    <div className={s.liveBlinker}>
                      <i className={`${s.liveBtn} ${s.white}`} />
                      <span>Live</span>
                    </div>
                    {sectionData.hl}
                  </figcaption>
                  <figure>
                    <ImageV2
                      key={sectionData.id}
                      width={imgWidth}
                      placeHolderSrc={`${TOI_IMAGE_DOMAIN}/thumb/83033472.cms`}
                      src={`${TOI_IMAGE_DOMAIN}/thumb/imgsize-${
                        sectionData?.imagesize
                      },msid-${
                        sectionData?.imageid
                      },width-${imgWidth},resizemode-4/${
                        sectionData?.imageid
                      }.jpg`}
                      alt={sectionData.hl}
                      lazyload
                      offsetVertical={300}
                      addFetchPriorityHighAttribute={
                        this.props.addFetchPriorityHighAttribute
                      }
                    />
                  </figure>
                </div>
              </div>
            </Link>
            {isRelatedStoriesPresent && (
              <RelatedStoriesCardBottom
                data={sectionData}
                wrapperClass="lbInsertRelatedStoriesContainer"
              />
            )}
            {sectionData &&
              sectionData.secdetail &&
              (sectionData.secdetail.displayTime ||
                (sectionData.secdetail.hl && sectionData.secdetail.wu)) && (
                <CardBottom secdetail={sectionData.secdetail} />
              )}
          </div>
        </>
      );
    } else if (
      sectionData &&
      sectionData.type &&
      sectionData.type === 'lbgfeatured'
    ) {
      return (
        <>
          <Card
            data={sectionData}
            isLeadImageNews
            isInlineSmallIconCard={false}
            itemClass={itemIndex >= 0 && s.leadspacing}
            linkData={{
              gaAction: `${datanewga}`,
              gaLabel: `${sectionData.wu}`,
            }}
            ga4Type={ga4Type}
          />
          {!isBudget && (
            <div className="liveBlogDataWrapper">
              <div className={s.LB_wrapper}>
                {data &&
                  data.id && (
                    <div>
                      <Link
                        className={s.LB_timeline_wrapper}
                        to={sectionData.wu}
                        data-newga={`${datanewga}#sectionData.wu`}
                        ga4Data={
                          sectionId === 'topstories'
                            ? [
                                {
                                  event: 'user_click',
                                  type: `main_line_up`,
                                  label: `liveblog`,
                                  category: `story_click`,
                                  story_no: `${itemIndex}`,
                                  msid: sectionData?.id,
                                },
                              ]
                            : ga4Type &&
                              ga4Type !== 'top_stories' && [
                                {
                                  event: 'user_click',
                                  type: `${ga4Type}`,
                                  category: 'story_click',
                                  story_no: `${itemIndex}`,
                                  msid: sectionData?.id,
                                },
                              ]
                        }
                      >
                        <div className={s.LB_timeline}>
                          <div className={s.liveBlinker} />
                          <div className={s.LB_timetext}>{data.upd}</div>
                          <div className={s.LB_timeline_content}>{data.hl}</div>
                        </div>
                      </Link>
                      <Link
                        className={s.LB_moreupdate}
                        to={sectionData.wu}
                        data-newga={`${datanewga}#sectionData.wu`}
                      >
                        <span>{data.moreText}</span>
                      </Link>
                    </div>
                  )}
              </div>
            </div>
          )}
        </>
      );
    }
    return (
      // <div className="liveBlogDataWrapper">
      <div className={`liveBlogDataWrapper ${s.LB_wrapper}`}>
        {/* <Card
          data={sectionData}
          // showDescription={itemIndex <= leadImageUpperLimit}
          isLeadImageNews={isLead}
          isInlineSmallIconCard={!isLead}
          itemClass={itemIndex >= 0 && s.leadspacing}
          linkData={{
            gaAction,
            gaLabel: `${sectionData.name}Click/${itemIndex}/${sectionData.wu}`,
          }}
        /> */}
        <Link
          to={sectionData.wu}
          className={s.LB_heading}
          data={{
            gaAction: `${gaAction}-${itemIndex}`,
            gaLabel: `${sectionData.wu}`,
          }}
          ga4Data={
            sectionId === 'topstories'
              ? [
                  {
                    event: 'user_click',
                    type: `main_line_up`,
                    label: `liveblog`,
                    category: `story_click`,
                    story_no: `${itemIndex}`,
                    msid: sectionData?.id,
                  },
                ]
              : ga4Type &&
                ga4Type !== 'top_stories' && [
                  {
                    event: 'user_click',
                    type: `${ga4Type}`,
                    category: 'story_click',
                    story_no: `${itemIndex}`,
                    msid: sectionData?.id,
                  },
                ]
          }
        >
          {sectionData.hl}
        </Link>
        {sectionData &&
          sectionData.secdetail &&
          (sectionData.secdetail.displayTime ||
            (sectionData.secdetail.hl && sectionData.secdetail.wu)) && (
            <CardBottom secdetail={sectionData.secdetail} />
          )}
        {this.state.loading &&
          !(data && data.id) && (
            <div className={`${s.LB_timeline_wrapper} ${s.LBInsertLoader}`}>
              <div className={s.LB_timeline}>
                <div className={s.liveBlinker} />
                <Lineshimmer />
              </div>
            </div>
          )}
        {data &&
          data.id && (
            <div>
              <Link
                className={s.LB_timeline_wrapper}
                to={sectionData.wu}
                data={{
                  gaAction: `${gaAction}-${itemIndex}`,
                  gaLabel: `${sectionData.wu}`,
                }}
              >
                <div className={s.LB_timeline}>
                  <div className={s.liveBlinker} />
                  <div className={s.LB_timetext}>{data.upd}</div>
                  <div className={s.LB_timeline_content}>{data.hl}</div>
                </div>
              </Link>
              <Link
                className={s.LB_moreupdate}
                to={sectionData.wu}
                data={{
                  gaAction: `${gaAction}-${itemIndex}`,
                  gaLabel: `${sectionData.wu}`,
                }}
              >
                <span>{data.moreText}</span>
              </Link>
            </div>
          )}
      </div>
      // </div>
    );
  }
}
LiveblogInsert.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  isLead: PropTypes.bool,
  itemIndex: PropTypes.number,
  gaAction: PropTypes.string,
  insertCaption: PropTypes.bool,
  isMobile: PropTypes.bool,
  enableRelatedStoriesSupport: PropTypes.bool,
  isCtnCpd: PropTypes.bool,
  addFetchPriorityHighAttribute: PropTypes.bool,
};
LiveblogInsert.defaultProps = {
  isLead: false,
  itemIndex: 0,
  gaAction: '',
  insertCaption: false,
  isMobile: false,
  enableRelatedStoriesSupport: false,
  isCtnCpd: false,
  addFetchPriorityHighAttribute: false,
};

const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

export default connect(mapStateToProps)(LiveblogInsert);
